.form-section {
  max-width: 490px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  flex-direction: column;

  .flex-group {
    display: flex;
    align-items: flex-start;

    gz-form-field:first-of-type {
      min-width: var(--form-field-label-width);
    }
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 1.5);
}

.form-subtitle + .form-section {
  margin-top: calc(var(--spacer) * 2.5);
}

.form-section + .form-subtitle {
  margin-top: calc(var(--spacer) * 3.5);
}

.form-subtitle-info + .form-section {
  margin-top: calc(var(--spacer) * 2);
}

.form-subtitle-error {
  margin-top: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  color: var(--red-layout-300-primary);
}

#section-general-details {
  margin-bottom: calc(var(--spacer) * 2.8);
}

#section-edit-details {
  gz-labeled-content {
    min-height: 24px;
    display: flex;
    align-items: center;
    margin-bottom: var(--spacer);
    &::part(container) {
      margin-bottom: 0;
    }
  }
}

.section-rule-details[disabled] {
  .form-subtitle,
  .form-subtitle-info {
    color: var(--grey-layout-200-disabled);
  }
}
